import { render, staticRenderFns } from "./ErrorStats.vue?vue&type=template&id=6505aa6c&scoped=true&"
import script from "./ErrorStats.vue?vue&type=script&lang=js&"
export * from "./ErrorStats.vue?vue&type=script&lang=js&"
import style0 from "./ErrorStats.vue?vue&type=style&index=0&id=6505aa6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505aa6c",
  null
  
)

export default component.exports